import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from "@/components/ui/alert-dialog";
import { Clock, Database } from "lucide-react";
import { formatImportTimestamp } from "@/hooks/use-import-persistence";

interface LoadSavedDataDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  onConfirm: () => void;
  onDecline: () => void;
  importedAt: string | null;
  dataType: string;
}

export function LoadSavedDataDialog({
  open,
  onOpenChange,
  onConfirm,
  onDecline,
  importedAt,
  dataType,
}: LoadSavedDataDialogProps) {
  return (
    <AlertDialog open={open} onOpenChange={onOpenChange}>
      <AlertDialogContent className="max-w-md">
        <AlertDialogHeader>
          <AlertDialogTitle className="flex items-center gap-2">
            <Database className="h-5 w-5 text-primary" />
            Saved Data Found
          </AlertDialogTitle>
          <AlertDialogDescription className="space-y-3">
            <p>
              You have previously saved <span className="font-semibold text-foreground">{dataType}</span> data in the database.
            </p>
            {importedAt && (
              <div className="flex items-center gap-2 text-sm bg-muted p-2 rounded-md">
                <Clock className="h-4 w-4 text-muted-foreground" />
                <span>Last saved: <span className="font-medium text-foreground">{formatImportTimestamp(importedAt)}</span></span>
              </div>
            )}
            <p>Would you like to load this saved data?</p>
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel onClick={onDecline}>
            Start Fresh
          </AlertDialogCancel>
          <AlertDialogAction onClick={onConfirm}>
            Load Saved Data
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
